import request from '@/api/config/request'

const prex = "api/nota";

export function listNotas(eco_codigo, query = {}) {
    return request({
        url: `${prex}/list/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function listNotasSimples(eco_codigo, competencia) {
    return request({
        url: `${prex}/list_simples/${eco_codigo}/${competencia}`,
        method: 'get'
    })
}

export function listNotasTributaveis(eco_codigo, query = {}) {
    return request({
        url: `${prex}/list_tributavel/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function getNotaFiscal(not_hash, query = {}) {
    return request({
        url: `${prex}/${not_hash}`,
        method: 'get',
        params: query
    })
}

export function listNotasPedidosCancelamento(eco_codigo, query = {}) {
    return request({
        url: `${prex}/cancelamento/pedidos/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function getNotaPedidoCancelamento(eco_codigo, codigo) {
    return request({
        url: `${prex}/cancelamento/pedidos/${eco_codigo}/${codigo}`,
        method: 'get'
    })
}

export function getEnviaEmailNotaFiscal(not_hash) {
    return request({
        url: `${prex}/email/${not_hash}`,
        method: 'get',
    })
}

export function gerarNota(data) {
    return request({
        url: `${prex}/gerar`,
        method: 'post',
        data
    })
}

export function cancelarNota(data) {
    return request({
        url: `${prex}/cancelar`,
        method: 'post',
        data
    })
}

export function downloadNota(not_hash) {
    return request({
        url: `relatorio/nota_fiscal/download/${not_hash}`,
        method: 'get'
    })
}

export function downloadNotaXML(not_hash) {
    return request({
        url: `relatorio/nota_fiscal/download/xml/${not_hash}`,
        method: 'get'
    })
}

export function downloadLoteXML(data) {
    return request({
        url: `relatorio/nota_fiscal/download/xml/lote`,
        method: 'post',
        data
    })
}

export function listDescricaoFavorita(query = {}) {
    return request({
        url: `${prex}/descricao`,
        method: 'get',
        params: query
    })
}

export function saveDescricaoFavorita(data) {
    return request({
        url: `${prex}/descricao`,
        method: 'post',
        data
    })
}

export function deleteDescricaoFavorita(eco_codigo, id) {
    return request({
        url: `${prex}/descricao/${eco_codigo}/${id}`,
        method: 'delete'
    })
}

export function getNotaFiscalTributacaoSimples(data) {
    return request({
        url: `${prex}/tributacao`,
        method: 'post',
        data
    })
}
